import * as yup from 'yup'

const profileSchema = yup
  .number()
  .required('Selecione um perfil')
  .typeError('Selecione um perfil')

const schemaUser = (userClient, isEdit, profileResponsible) =>
  yup.object().shape({
    name: yup.string().trim().required(),
    email: yup.string().email().required(),
    ...((!userClient || (userClient && !isEdit)) && {
      profileId: profileSchema,
    }),
    ...(userClient &&
      !isEdit && {
        companyId: yup.object().required('Selecione uma empresa').nullable(),
        profileId: profileSchema,
        linkType: yup.string().required(),
      },
    profileResponsible && {
      phone: yup.string().phone({ required: true }),
    }),
    ...(userClient &&
      isEdit &&
      profileResponsible && {
        cpf: yup.string().cpf(),
      }),
    ...(!userClient && {
      phone: yup.string().nullable().phone(),
    }),

    company: yup.object().when('linkType', {
      is: (linkType) => linkType && linkType === 'userCompany',
      then: yup.object().required().typeError('Preencha esse campo'),
      otherwise: yup.object().notRequired(),
    }),

    organization: yup.object().when('linkType', {
      is: (linkType) => linkType && linkType === 'organizationUser',
      then: yup.object().required().typeError('Preencha esse campo'),
      otherwise: yup.object().notRequired(),
    }),
  })

export default schemaUser
